const initialState = {
    data: [],
    msgdata:[],
    };
  
  const Dchart = (state = initialState, action: any) => {
    switch (action.type) {
      case 'FETCH_DATA_SUCCESS':
        return { ...state, data: action.payload };
      case 'FETCH_DATA_SUCCESS_MAG':
        return{ ...state, msgdata: action.payload }
      default:
        return state;
    }
  };
  
  export default Dchart;
  
  